import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'ml.common.vehiclesList.Vehicles',
        defaultMessage: 'Vehicles'
    },
    description: {
        id: 'ml.common.vehiclesList.Below is the list of your vehicles',
        defaultMessage: 'Below is the list of your vehicles'
    },
    vehicleInfo: {
        id: 'ml.common.vehiclesList.vehicleInfo',
        defaultMessage: '{vehicle} (Vehicle #{vehicleNumber})'
    },
    whoPrimarilyDrivesThisVehicle: {
        id: 'ml.common.vehiclesList.Who primarily drives this vehicle?',
        defaultMessage: 'Who primarily drives this vehicle?'
    },
    tooltipLabel: {
        id: 'ml.common.vehiclesList.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    driverTooltipContent: {
        id: 'ml.common.vehiclesList.driverTooltipContent',
        defaultMessage: 'This is the driver who uses this vehicle most often Resident students do not need to be assigned as primary driver on a vehicle.'
    },
    percentageDriverLabel: {
        id: 'ml.common.vehiclesList.percentageDriverLabel',
        defaultMessage: 'Indicate percentage each driver uses this vehicle (from 0 to 100 percent)'
    },
    percentageDriverTooltipContent: {
        id: 'ml.common.vehiclesList.percentageDriverTooltipContent',
        defaultMessage: `<p>Indicate a percentage for all drivers who use this vehicle. If a listed driver does not use the vehicle, indicate 0 as the percent for that driver.
        When there are multiple drivers, percentages cannot equal for all drivers on a vehicle (example:  50% driver 1; 50% driver 2).
        Each driver must be shown as the highest percentage on a vehicle before the driver can listed as the highest percentage on another vehicle.</p>
        <p>For each vehicle, the driver with the highest percentage is considered the primary driver (example:  on vehicle 1 driver 1 uses vehicle 40%, driver 2 uses vehicle 30%, driver 3 uses vehicle 30% -  driver 1 would be considered the primary driver).
          When determining total percentage of use, consider the total time the vehicle is used and/or annual miles driven per driver.</p>
        `
    },
    totalPercentageDesc: {
        id: 'ml.common.vehiclesList.totalPercentageDesc',
        defaultMessage: 'Total for each vehicle must equal 100'
    },
    vehicleX: {
        id: 'ml.common.vehiclesList.Vehicle x',
        defaultMessage: 'Vehicle {vehicleNumber}'
    },
    vehicleXForGPA: {
        id: 'ml.common.vehiclesList.vehicle X For GPA',
        defaultMessage: '(Vehicle #{vehicleNumber})'
    }
});
